<template lang="pug">
  .qty-buttons-v3.xs-f-small.lg-f-xsmall.max-at-tweak(ref="qtyButtonsV3" :class="{ 'wide': isWide }")
    button.decrement(@click="decrementQty" :class="{ 'disabled': minQtyReached }" :aria-disabled="minQtyReached" data-mr-ass="quantity-down" aria-label='Decrease') &minus;

    .qty(data-mr-ass="product-quantity" aria-live="polite" :aria-label="'Quantity ' + localQty" tabindex="0" role="status") {{ displayQty }}

    button.increment(@click="incrementQty" :class="{ 'disabled': maxQtyReached }" :aria-disabled="maxQtyReached" data-mr-ass="quantity-up" aria-label='Increase') &plus;

</template>

<script lang="js">
  import QtyButtonBase from '@components/QtyButtonBase.vue';

  export default {
    name: 'QtyButtonsV3',
    extends: QtyButtonBase,

    data() {
      return {
        isWide: false
      };
    },

    computed: {
      displayQty() {
        if (this.isWide) {
          return `Qty: ${this.localQty}`;
        } else {
          return this.localQty;
        }
      }
    },

    mounted() {
      this.checkDimensions();
      window.addEventListener('resize', this.checkDimensions);
    },

    beforeUnmount() {
      window.removeEventListener('resize', this.checkDimensions);
    },

    methods: {
      checkDimensions() {
        const el = this.$refs.qtyButtonsV3;
        if (el) {
          const width = el.offsetWidth;
          const height = el.offsetHeight;
          this.isWide = width > 4 * height;
        }
      }
    }
  };
</script>


<style scoped lang="stylus">
  .qty-buttons-v3
    display flex
    align-items stretch
    height 100%
    width 100%
    border 1px solid color-fog
    max-height 52px

    > *
      flex 1 1 0
      aspect-ratio 1 / 1
      min-width 0
      min-height 0
      display flex
      align-items center
      justify-content center

    button
      background-color #fff
      color brand-color-1
      padding 0
      font-size 1.3em
      font-weight bold

    .qty
      color brand-color-1
      font-size 1em

    .decrement
    .increment
      cursor pointer
      border none

      &.disabled
        span
          color color-fog

    &.wide
      .decrement
      .increment
        flex 0 0 18%
        max-width 18%
</style>